import EntityService from "./entity";

class ExhibitService extends EntityService {
  constructor(name) {
    super(name)
  }
}

export default new ExhibitService("venue")



// WEBPACK FOOTER //
// ./src/services/venue.js